import { useEffect, useState } from "react";

import {
  Button,
  Empty,
  message,
  Collapse,
  Popconfirm,
  Progress,
  Alert,
} from "antd";
import { PageLoading } from "..";
import dayjs from "dayjs";
const Index = (props) => {
  const { collect } = props;
  const [loading, setLoading] = useState(false);
  const [detail, setDetail] = useState([]);
  const [activeKey, setActiveKey] = useState(null);

  useEffect(() => {
    props?.request({ url: "/order/time/list", model: "times" });
    props?.request({ url: "/order/config", model: "adminconfig" });
  }, []);

  useEffect(() => {
    if (activeKey) {
      props
        .request({
          url: `/order/order/checkdate/${dayjs(activeKey)?.format(
            "YYYY-MM-DD"
          )}`,
        })
        ?.then((res) => {
          if (res.success) {
            setDetail(res?.data);
          }
        });
    }
  }, [activeKey]);

  const handleNext = () => {
    if (collect?.time) {
      sendOrder();
    } else {
      message.error("Цаг сонгоно уу.");
    }
  };

  const sendOrder = () => {
    const date = `${dayjs(collect?.time?.date)?.format("YYYY-MM-DD")} ${
      collect?.time?.time
    }:00:00`;
    const dateTime = dayjs(date, "YYYY-MM-DD HH:mm").tz("UTC", true);
    let body = {
      phone: collect?.phonen,
      orderdate: dateTime?.toISOString(),
      deviceid: collect?.service?.id,
      hour: collect?.service?.hour,
      amount: collect?.time?.amount || 0,
      carnumber: collect?.info?.plateNumber || "",
      carbrand: collect?.info?.markName || "",
      carmodel: collect?.info?.modelName || "",
      carcabinnumber: collect?.info?.cabinNumber || "",
      carcountry: collect?.info?.countryName || "",
      carwheel: collect?.info?.wheelPosition || "",
      carfuel: collect?.info?.fuelType || "",
      carbuildyear: collect?.info?.buildYear?.toString(),
    };
    setLoading(true);
    props
      ?.request({ url: `/order/user`, method: "POST", body: body })
      ?.then((res) => {
        setLoading(false);
        if (res.success) {
          props?.setCollect({ ...props?.collect, orderdata: res?.data });
          props?.setStep(props?.step + 1);
          message.success(res.message);
        } else {
          message.error(res.message);
        }
      });
  };

  const handlePrev = () => {
    props?.setStep(props?.step - 1);
  };

  const handleTime = (date, time, amount) => {
    console.log(date, time);
    props?.setCollect({
      ...collect,
      time: { date: date, time: time, amount: amount },
    });
  };

  const isActiveTime = (date, time) => {
    if (collect?.time?.date === date && collect?.time?.time === time)
      return "primary";
    return "";
  };

  const getData = () => {
    const tmp = props?.restimes?.map?.((item) => {
      let sub = detail?.map?.((sub, i) => {
        const fillPercentage = (sub?.ordercount / item?.staffqty) * 100;
        return (
          <div className="col-span-2 flex flex-col">
            <Button
              key={i}
              onClick={() => handleTime(item.date, sub?.hour, item?.amount)}
              disabled={sub?.isdisable || loading}
              type={isActiveTime(item.date, sub.hour)}
              className="col-span-2 flex justify-center w-full text-sm text-center"
            >
              {`${sub?.hour}:00`}
            </Button>
            <Progress
              percent={fillPercentage}
              size={{ height: 3 }}
              status="active"
              showInfo={false}
              // format={(x) => <span>{Math.floor(x)}</span>}
              strokeColor={"#072040"}
              // percentPosition={{
              //   align: "center",
              //   type: "outer",
              // }}
              className="text-primary"
            />
          </div>
        );
      });
      const activeTime = detail?.filter((x) => !x.isdisable);

      return {
        key: item?.date,
        className: "bg-black/5 rounded-md mt-1",
        label: (
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <span className="font-bold">
                {dayjs(item?.date)?.format("YYYY/MM/DD")}
              </span>
              <span className="text-xs text-black/60">{`${item?.starthour} - ${item?.endhour}`}</span>
              {item?.amount ? (
                <span className="text-xs text-black/60">
                  Захиалга баталгаажуулах төлбөр:
                  <span className="ml-2 text-[1rem] text-primary ">
                    {new Intl.NumberFormat().format(item?.amount || 0)}₮
                  </span>
                </span>
              ) : null}
            </div>
          </div>
        ),
        children: (
          <div className="grid grid-cols-12 gap-1.5">
            {sub}
            {activeTime?.length === 0 && detail?.length > 0 ? (
              <div className="col-span-12">
                <span className="text-xs text-danger/80">
                  Тухайн өдрийн цаг дүүрсэн байна.
                </span>
              </div>
            ) : null}
            {detail?.length === 0 ? (
              <div className="col-span-12">
                <span className="text-xs text-danger/80">
                  Боломжит цаг байхгүй байна.
                </span>
              </div>
            ) : null}
            {item?.taxhour > 0 &&
            item?.taxhour < collect?.time?.time &&
            item?.date === collect?.time?.date ? (
              <div className="col-span-12">
                <span className="text-xs text-danger/80">
                  Тухайн сонгосон цаг нэмэлт төлбөртэйг анхаарна уу.
                </span>
              </div>
            ) : null}
          </div>
        ),
      };
    });

    return tmp;
  };

  const onChangeCollapse = (e) => {
    setActiveKey(e[0]);
  };

  const readyData = getData();

  return (
    <div className="flex justify-center flex-col items-center w-full">
      <Alert
        type="info"
        message="Та захиалга баталгаажуулах төлбөрөө төлж цагтаа үйлчилгээгээ авсанаар таны төлөлт нийт дүнгээс хасагдах болно."
        className="w-full lg:w-3/6 mb-2 text-xs"
        showIcon
      />

      {props?.istimes === true ? <PageLoading /> : null}

      {props?.restimes?.length ? (
        <div className="flex flex-col gap-3 w-full lg:w-3/6">
          <Collapse
            items={readyData || []}
            className="bg-white w-full"
            bordered={false}
            activeKey={activeKey}
            accordion
            onChange={onChangeCollapse}
          />
          {props?.resadminconfig?.text ? (
            <Alert
              type="error"
              className="w-full mt-4"
              message={props?.resadminconfig?.text}
            />
          ) : null}

          <div className="flex justify-between mt-5">
            <Button className="" onClick={handlePrev} loading={loading}>
              Буцах
            </Button>
            <Popconfirm
              placement="topLeft"
              title="Анхааруулга"
              description={"Захиалга үүсгэхдээ итгэлтэй байна уу ?"}
              okText="Тийм"
              cancelText="Үгүй"
              onConfirm={handleNext}
            >
              <Button type="primary" loading={loading}>
                Үргэлжлүүлэх
              </Button>
            </Popconfirm>
          </div>
        </div>
      ) : (
        <div className="mt-5 w-full">
          <Empty imageStyle={{ height: 50 }} />
          {props?.resadminconfig?.text ? (
            <Alert
              type="error"
              className="w-full mt-4"
              message={props?.resadminconfig?.text}
            />
          ) : null}
        </div>
      )}
    </div>
  );
};

export default Index;
